import { useSelector } from "react-redux";
import { getMemberDisplayName } from "utils/v3/memberDisplayNameUtils";
import { selectUserPersonalInformation } from "../../../../../store/reducers/user/UserAccountSlice";

const ContentResolver = (props) => {
  const userInformation = useSelector(selectUserPersonalInformation);

  const content = props.content.replace(
    "{{{userFirstName}}}",
    getMemberDisplayName(userInformation)
  );
  return <span dangerouslySetInnerHTML={{ __html: content }} />;
};

export default ContentResolver;
